import { render } from "./RouletteHeader.vue?vue&type=template&id=c55ec990&scoped=true"
import script from "./RouletteHeader.vue?vue&type=script&lang=js"
export * from "./RouletteHeader.vue?vue&type=script&lang=js"

import "./RouletteHeader.vue?vue&type=style&index=0&id=c55ec990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c55ec990"]])

export default __exports__